import io from "socket.io-client";
import store from "@/stores/store";
import { MSEnum } from '@/commons/enumeration';
import { ModuleExport, ModuleImport } from '@/stores/moduleConst.js';
import { I18nInjectionKey } from 'vue-i18n';
import { SocketEvent } from './socket-constant';
import i18nGlobal from '@/i18ns/i18n';
const i18n = i18nGlobal.global;
import FileAPI from '@/apis/other/fileAPI.js';
import NotificationAPI from '@/apis/other/notificationAPI';
import WebSocketAPI from '@/apis/system/socketAPI';

class WebSocket {
  // khởi tạo instance
  createInstance(store) {
    let websocket = new WebSocket(store);
    websocket.store = store;
    return websocket
  }

  // get instance static
  getInstance(store) {
    if (!this.instance) {
      this.instance = this.createInstance(store);
    }
    return this.instance;
  }



  /**
 * Thực hiện kết nối và xử lý socket
 */
  connectSocket = (proxy) => {
    WebSocketAPI.getRooms().then((rooms) => {
      let socket = io(window._socketUrl, {
        reconnection: true,
        reconnectionAttempts: 5,
        transports: ['websocket'],
      });

      socket.on('connect', function () {
        // Kết nối tới socket
        socket.emit(SocketEvent.JoinRoom, rooms);

        // lắng nghe các event từ socket
        socket.on(SocketEvent.Connected, (token) => {
          console.log(`Connect socket success: ${token}`);
        });

        // Khi có sự thay đổi trên socket server Nhận dữ liệu về qua một new_event sau đó callback func
        socket.on(SocketEvent.Notification, (res) => {
          onDataChanged(res);
        });

        // hứng thông báo từ socket khi xuất khẩu thành công
        socket.on(SocketEvent.Export, (res) => {
          getDownloadFile(res);
        });
      });

      // hứng kết quả trả về bước 3 nhập khẩu
      socket.on(SocketEvent.ImportStep3, (res) => {
        if (res && res != MSEnum.ServerErrorCodes.Worker) {
          store.commit(`${ModuleImport}/setImportResultWorker`, JSON.parse(res));
          store.commit(`${ModuleImport}/triggerAddStep`);
        } else {
          proxy.$toast.error(i18n.t('i18nCommon.ErrorOccurMsg'));
        }
      });

      // hứng kết quả trả về bước 4 nhập khẩu
      socket.on(SocketEvent.ImportStep4, (res) => {
        if (res && res != MSEnum.ServerErrorCodes.Worker) {
          proxy.$toast.success(i18n.t('i18nImport.ImportSuccess'));
          store.commit(`${ModuleImport}/setImportResultWorker`, JSON.parse(res));
          store.commit(`${ModuleImport}/setImportResult`, true);
        } else {
          proxy.$toast.error(i18n.t('i18nCommon.ErrorOccurMsg'));
          store.commit(`${ModuleImport}/setImportResult`, false);
        }
      });
    });

  };
}

/**
 * lấy file xuất khẩu từ kết quả trả về từ socket
 * 1. ClientFileName: tên file lưu trên server
 * 2. ParamData: là config truyền từ client lên
 * created by lkphuc 01.03.2023
 */
const getDownloadFile = async (res) => {
  let config = JSON.parse(res);
  if (config && config.ParamData && config.ReportId) {
    let process = store.getters[`${ModuleExport}/exportProcess`](
      config.ReportId
    );
    if (process) {
      if (config.ClientFileName) {
        store.commit(
          `${ModuleExport}/updateSuccessStatusExportProcess`,
          config.ReportId
        );

        let src = FileAPI.getDownloadLink(
          0,
          process.NameFileServer,
          process.NameFileClient,
          MSEnum.AppCode
        );

        window.open(src);
      } else {
        store.commit(
          `${ModuleExport}/updateFailStatusExportProcess`,
          config.ReportId
        );
      }
    }
  }
};


/**
 * Khi có sự thay đổi trên socket server Nhận dữ liệu về qua một new_event sau đó callback func
 */
const onDataChanged = async (res) => {
  const param = {
    skip: 0,
    take: 15,
    appCode: MSEnum.AppCode,
    isView: null,
    userID: store.state.context.User.UserID,
  };

  // Lấy và bind số lượng thông báo chưa đọc
  store.dispatch('notification/fetchUnreadNotificationsCount', param);

  // Lấy thông báo đầu tiên
  const notifyList = await NotificationAPI.getPagingNotifications({
    ...param,
    IsView: null,
  });

  if (notifyList) {
    if (notifyList?.length) {
      const firstNotify = notifyList[0];
      // nếu thông báo đầu tiên đã được xem thì ko hiển thị nữa
      if (firstNotify.IsView) {
        return;
      }
      store.dispatch('notification/setNewNotify', firstNotify);
      store.dispatch('notification/toggleToastMsgNotify', true);
    }
  }
};

const webSocketInstance = new WebSocket().getInstance(store)

export default webSocketInstance
